/**
 * A Storyblok Rich Text field the author never filled in still holds one empty
 * paragraph:
 * {
 *  "type": "doc",
 *    "content": [
 *      {
 *       "type": "paragraph"
 *      }
 *    ]
 *  }
 * So the field counts as filled in as soon as it holds any node that is not
 * such an empty paragraph. An image, a rule, a break or an embedded block are
 * all content, even though they carry no text of their own.
 */
import { StoryblokRichTextDoc } from "../../.storyblok/types/storyblok";

type RichTextNode = StoryblokRichTextDoc["content"][number];

const isEmptyParagraph = (node: RichTextNode) =>
  node.type === "paragraph" && !node.content?.length;

export const isSbRichTextNotEmpty = (
  field: StoryblokRichTextDoc | null | undefined,
) =>
  Array.isArray(field?.content) &&
  field.content.some((node) => !isEmptyParagraph(node));
